import React from 'react';
import { QueryDataTable } from '~/shared/data-tables/query/QueryDataTable';
import type { GroupVisitToTableProps } from './types';

type DisciplineSearchOptionType = 'schedule-report-totals-discpline' | 'schedule-report-totals-discpline-unassigned';

export function GroupVisitsByDiscplineTable<T extends DisciplineSearchOptionType>(props: GroupVisitToTableProps<T>) {
	return (
		<QueryDataTable<T>
			searchType={props.searchType}
			columns={props.columnDefinitions}
			staticFilters={props.staticFilters}
			getRowId={x => x.discipline.toString()}
			renderRowDetail={row => (
				<props.tableComponent type="inner-with-filters" staticFilters={[{ name: 'discipline', operator: '==', value: row.discipline }]} />
			)}
			emptyMessage="No visits found"
		/>
	);
}
